
import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import RevenueSplitActions from './RevenueSplitActions';

interface NewRevenueSplitFormProps {
  newSplit: {
    volumeThreshold: number;
    masterLicensePercentage: number;
    resellerPercentage: number;
    isActive: boolean;
  };
  setNewSplit: React.Dispatch<React.SetStateAction<{
    volumeThreshold: number;
    masterLicensePercentage: number;
    resellerPercentage: number;
    isActive: boolean;
  }>>;
  handleNewMasterPercentageChange: (value: number) => void;
  handleNewResellerPercentageChange: (value: number) => void;
  handleAddNew: () => void;
  setIsAdding: React.Dispatch<React.SetStateAction<boolean>>;
}

const NewRevenueSplitForm: React.FC<NewRevenueSplitFormProps> = ({
  newSplit,
  setNewSplit,
  handleNewMasterPercentageChange,
  handleNewResellerPercentageChange,
  handleAddNew,
  setIsAdding
}) => {
  return (
    <Card className="mb-6 border-dashed border-2 border-blue-200 bg-blue-50">
      <CardHeader className="pb-2">
        <CardTitle className="text-lg">New Revenue Split Tier</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
          <div>
            <Label htmlFor="new-threshold">Volume Threshold ($)</Label>
            <Input 
              id="new-threshold" 
              type="number"
              value={newSplit.volumeThreshold} 
              onChange={(e) => setNewSplit({...newSplit, volumeThreshold: parseInt(e.target.value)})}
              placeholder="10000"
            />
            <p className="text-xs text-muted-foreground mt-1">
              Monthly revenue threshold to qualify for this split
            </p>
          </div>
          <div className="flex items-center space-x-2">
            <Switch 
              id="new-active" 
              checked={newSplit.isActive} 
              onCheckedChange={(checked) => setNewSplit({...newSplit, isActive: checked})}
            />
            <Label htmlFor="new-active">Active</Label>
          </div>
          <div>
            <Label htmlFor="new-master-percentage">Master License Percentage (%)</Label>
            <Input 
              id="new-master-percentage" 
              type="number"
              value={newSplit.masterLicensePercentage} 
              onChange={(e) => handleNewMasterPercentageChange(parseInt(e.target.value))}
            />
          </div>
          <div>
            <Label htmlFor="new-reseller-percentage">Reseller Percentage (%)</Label>
            <Input 
              id="new-reseller-percentage" 
              type="number"
              value={newSplit.resellerPercentage} 
              onChange={(e) => handleNewResellerPercentageChange(parseInt(e.target.value))}
            />
          </div>
        </div>
        <RevenueSplitActions 
          setIsAdding={setIsAdding}
          handleAddNew={handleAddNew}
        />
      </CardContent>
    </Card>
  );
};

export default NewRevenueSplitForm;
